/**
 * Cart Upsell Slider - Simplified Version
 * Handles carousel navigation and AJAX cart functionality
 */

class CartUpsellSlider {
  updateNavButtons() {
    if (!this.prevBtn || !this.nextBtn) return;
    
    // Tek ürün kaldıysa okları gizle
    if (this.items.length <= 1) {
      this.prevBtn.style.display = 'none';
      this.nextBtn.style.display = 'none';
      return;
    }
    
    // Birden fazla ürün varsa okları göster
    this.prevBtn.style.display = '';
    this.nextBtn.style.display = '';
  }
  constructor(element) {
    this.carousel = element;
    this.track = element.querySelector('[data-carousel-track]');
    this.wrapper = element.querySelector('.cart-upsell__track-wrapper');
    this.prevBtn = element.querySelector('[data-carousel-prev]');
    this.nextBtn = element.querySelector('[data-carousel-next]');
    this.items = element.querySelectorAll('.cart-upsell__item');
    
    if (!this.track || !this.items.length) return;
    
    // Prevent double initialization
    if (element.hasAttribute('data-initialized')) return;
    element.setAttribute('data-initialized', 'true');
    
    this.currentIndex = 0;
    this.isTransitioning = false;
    
    // Get responsive settings
    this.itemsPerView = {
      mobile: parseInt(element.dataset.itemsMobile) || 1,
      desktop: parseInt(element.dataset.itemsDesktop) || 3
    };
    
    this.init();
  }
  
  init() {
    this.setupLayout();
    this.bindEvents();
    this.setupCartButtons();
    this.updateNavButtons();
    
    // Update layout on resize
    window.addEventListener('resize', this.debounce(() => {
      this.setupLayout();
    }, 250));
  }
  
  setupLayout() {
    // Basit mantık: Her item 100% genişlikte
    this.maxIndex = this.items.length - 1;
    
    // İlk kurulumda pozisyonu güncelle
    if (this.currentIndex === undefined) {
      this.currentIndex = 0;
      this.updateTrackPosition();
    }
  }
  
  bindEvents() {
    if (this.prevBtn) {
      this.prevBtn.addEventListener('click', () => this.prev());
    }
    
    if (this.nextBtn) {
      this.nextBtn.addEventListener('click', () => this.next());
    }
  }
  
  setupCartButtons() {
    // Use event delegation to handle dynamically added buttons
    this.carousel.addEventListener('click', (e) => {
      if (e.target.matches('.cart-upsell__add') || e.target.closest('.cart-upsell__add')) {
        e.preventDefault();
        const button = e.target.matches('.cart-upsell__add') ? e.target : e.target.closest('.cart-upsell__add');
        this.addToCart(button);
      }
    });
  }
  
  prev() {
    if (this.isTransitioning) return;
    
    // Infinite loop: go to end if at beginning
    this.currentIndex = this.currentIndex === 0 ? this.maxIndex : this.currentIndex - 1;
    this.updateTrackPosition();
  }
  
  next() {
    if (this.isTransitioning) return;
    
    // Infinite loop: go to beginning if at end
    this.currentIndex = this.currentIndex === this.maxIndex ? 0 : this.currentIndex + 1;
    this.updateTrackPosition();
  }
  
  updateTrackPosition() {
    if (this.isTransitioning) return;
    
    this.isTransitioning = true;
    
    // Basit yüzde bazlı kaydırma
    const translateX = -(this.currentIndex * 100);
    this.track.style.transform = `translateX(${translateX}%)`;
    
    // Reset transition lock after animation
    setTimeout(() => {
      this.isTransitioning = false;
    }, 300);
  }
  
  async addToCart(button) {
    if (button.disabled) return;
    
    const variantId = button.dataset.variantId;
    if (!variantId) return;
    
    // Update button state
    button.disabled = true;
    button.textContent = 'Adding...';
    
    try {
      // Use the same approach as theme's quantity inputs
      const formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', '1');
      
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      });
      
      if (response.ok) {
        // Success
        button.textContent = 'Added ✓';
        button.classList.add('success');
        
        // Trigger cart update the simplest way possible
        this.simpleCartUpdate();
        
        // Ürün başarıyla eklendikten sonra
        setTimeout(() => {
          // Ürünü upsell listesinden kaldır
          const item = button.closest('.cart-upsell__item');
          if (item) {
            // Animasyonlu silme
            item.style.transition = 'all 0.3s ease';
            item.style.opacity = '0';
            item.style.transform = 'translateY(10px)';
            
            setTimeout(() => {
              // Ürünü DOM'dan kaldır
              item.remove();
              
              // Kalan ürünleri kontrol et
              const remainingItems = this.carousel.querySelectorAll('.cart-upsell__item');
              
              if (remainingItems.length > 0) {
                // Slider'ı güncelle
                this.items = remainingItems;
                this.maxIndex = Math.max(0, remainingItems.length - 1);
                
                // Eğer silinen son üründüyse bir öncekine geç
                if (this.currentIndex > this.maxIndex) {
                  this.currentIndex = this.maxIndex;
                }
                
                // Kaydırma pozisyonunu güncelle
                this.updateTrackPosition();
                
                // Ok butonlarını güncelle
                this.updateNavButtons();
              } else {
                // Hiç ürün kalmadıysa section'ı direkt gizle
                const section = this.carousel.closest('.cart-upsell');
                if (section) {
                  section.style.display = 'none';
                }
              }
            }, 300);
          }
        }, 1500);
        
      } else {
        throw new Error('Failed to add to cart');
      }
      
    } catch (error) {
      button.textContent = 'Error';
      button.classList.add('error');
      
      setTimeout(() => {
        button.textContent = 'Add';
        button.disabled = false;
        button.classList.remove('error');
      }, 2000);
    }
  }
  
  async simpleCartUpdate() {
    try {
      // Get cart state
      const cartResponse = await fetch('/cart.js');
      const cartData = await cartResponse.json();

      // Trigger all cart update events
      const events = ['cart:add', 'cart:update', 'cart:change', 'cart:refresh', 'cart:updated'];
      events.forEach(eventType => {
        document.dispatchEvent(new CustomEvent(eventType, {
          bubbles: true,
          detail: {
            cart: cartData,
            source: 'upsell-add'
          }
        }));
      });

      // Let cart-quantity.js handle the update
      // It will update all necessary sections including checkpoints bar and cart bubble

    } catch (error) {
      console.error('Cart update error:', error);
    }
  }
  
  // Simplified approach - let the theme handle cart updates
  
  async updateCartCount() {
    try {
      const response = await fetch('/cart.js');
      if (!response.ok) return;
      
      const cart = await response.json();
      if (!cart || typeof cart.item_count === 'undefined') return;
      
      // Update cart count elements
      const countElements = document.querySelectorAll('[data-cart-count]');
      countElements.forEach(el => {
        if (el) el.textContent = cart.item_count;
      });
      
      // Update cart count in common selectors
      const commonSelectors = [
        '.cart-count',
        '.cart-item-count',
        '#cart-icon-bubble span',
        '.cart-count-bubble'
      ];
      
      commonSelectors.forEach(selector => {
        try {
          const elements = document.querySelectorAll(selector);
          elements.forEach(el => {
            if (el) el.textContent = cart.item_count;
          });
        } catch (selectorError) {
          // Individual selector errors shouldn't break the whole function
        }
      });
      
    } catch (error) {
      // Don't log as error since this is non-critical
    }
  }
  
  // Utility function to debounce resize events
  debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }
}

// Auto-initialize when DOM is ready
function initCartUpsellSliders() {
  const sliders = document.querySelectorAll('[data-cart-upsell]:not([data-initialized])');
  sliders.forEach(slider => {
    new CartUpsellSlider(slider);
  });
}

// Initialize on DOM ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCartUpsellSliders);
} else {
  initCartUpsellSliders();
}

// IMPORTANT: Re-initialize when cart drawer opens or becomes visible
// This fixes the issue where upsell doesn't work on first cart open
document.addEventListener('click', (e) => {
  // Check if cart icon or cart trigger was clicked
  if (e.target.matches('[href="/cart"]') || 
      e.target.closest('[href="/cart"]') ||
      e.target.matches('.cart-count-bubble') ||
      e.target.closest('.cart-count-bubble') ||
      e.target.matches('#cart-icon-bubble') ||
      e.target.closest('#cart-icon-bubble')) {
    
    // Wait a bit for cart drawer to open and content to load
    setTimeout(() => {
      initCartUpsellSliders();
    }, 300);
  }
});

// Also listen for cart drawer opening events
document.addEventListener('cart:open', () => {
  setTimeout(initCartUpsellSliders, 200);
});

// Listen for any cart updates that might require re-initialization
document.addEventListener('cart:updated', () => {
  setTimeout(initCartUpsellSliders, 200);
});

// Use MutationObserver to detect when cart drawer content is added/changed
const observer = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    if (mutation.type === 'childList') {
      // Check if any new nodes contain our upsell slider
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE) {
          if (node.matches && node.matches('[data-cart-upsell]')) {
            setTimeout(() => new CartUpsellSlider(node), 100);
          } else if (node.querySelector) {
            const upsellSliders = node.querySelectorAll('[data-cart-upsell]:not([data-initialized])');
            upsellSliders.forEach(slider => {
              setTimeout(() => new CartUpsellSlider(slider), 100);
            });
          }
        }
      });
    }
  });
});

// Start observing cart drawer for changes
const startObserving = () => {
  const cartDrawer = document.querySelector('cart-drawer');
  if (cartDrawer) {
    observer.observe(cartDrawer, {
      childList: true,
      subtree: true
    });
  }
};

// Start observing when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', startObserving);
} else {
  startObserving();
}

// Export for manual initialization if needed
window.CartUpsellSlider = CartUpsellSlider;